/* Dot stepper — ported from the prototype's stepper(). Seven steps per deal;
   steps before the active one (or all, once a decision is logged) read as done. */
import React from 'react';
import { Link } from 'react-router-dom';

import { BASE } from '../helpers';
import { STEPS } from '../data/config';

export default function Stepper({ dealId, activeStep, decided = false }) {
	const activeIdx = STEPS.findIndex(s => s.id === activeStep);
	return (
		<div className="stepper">
			<div className="stepper__rail">
				{STEPS.map((s, i) => {
					const done = decided || i < activeIdx;
					const state = done ? 'is-done' : i === activeIdx ? 'is-active' : '';
					return (
						<Link key={s.id} className={`stepper__step ${state}`} to={`${BASE}/deal/${dealId}/${s.id}`}>
							<span className="stepper__dot">{done ? '✓' : i + 1}</span>
							<span className="stepper__name">{s.name}</span>
						</Link>
					);
				})}
			</div>
		</div>
	);
}
